module.exports = __webpack_public_path__ + "static/media/ing1.0448e5bf.jpg";